import React from 'react';
import PropTypes from 'prop-types';
import ProgressBar from 'src/components/progressBarBlue';
import Button from 'src/components/buttons/button';
import i18n from 'src/utils/translate';

const SurveyFooter = ({ progress = 0, disabled = false, onClickNext = () => {}, buttonText = 'Next', hideNext = false, buttonClass = '' }) => {
  return <div className="survey__footer">
    <div className="survey__footer-left">
      {progress}% {i18n.t('completed')}
      <ProgressBar progress={progress} />
    </div>
    {!hideNext && <div className="survey__footer-right">
      <Button
        disabled={disabled}
        text={<span>{buttonText}</span>}
        onClick={onClickNext}
      />
    </div>}
  </div>;
};

SurveyFooter.propTypes = {
  progress: PropTypes.number,
  isButtonEnabled: PropTypes.bool,
  hideNext: PropTypes.bool,
  disabled: PropTypes.bool,
  onClickNext: PropTypes.func,
  buttonText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  buttonClass: PropTypes.string,
};

export default SurveyFooter;
